module.exports = __webpack_public_path__ + "img/logo.9a906d0f.png";